import { FulfillmentGroupData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import { createContext, memo, ReactNode, useState } from "react";
import { SubmitShippingClaimModalWrapper } from "./shipping-claim-modal";

export const SubmitShippingClaimModalContext = createContext<
  (fulfillmentGroup: FulfillmentGroupData) => void
>(() => {});

export const SubmitShippingClaimModalProvider = memo(
  function SubmitShippingClaimModalProvider({
    children,
  }: {
    children: ReactNode;
  }) {
    const [fulfillmentGroup, setFulfillmentGroup] =
      useState<FulfillmentGroupData | null>(null);
    const [open, setOpen] = useState(false);

    const openModalWithGroup = (group: FulfillmentGroupData) => {
      setFulfillmentGroup(group);
      setOpen(true);
    };

    return (
      <SubmitShippingClaimModalContext.Provider value={openModalWithGroup}>
        {children}
        {fulfillmentGroup && (
          <SubmitShippingClaimModalWrapper
            isOpen={open}
            onClose={() => setOpen(false)}
            shippingClaimInput={{ type: "oms", fulfillmentGroup }}
          />
        )}
      </SubmitShippingClaimModalContext.Provider>
    );
  },
);
